import { ManuteRequestConfig } from '@/api/types';
import { RequestQueryParams } from '@/api/requests/types';
import { CompanyRequest } from '@/api/requests/profile/types';

const COMPANIES_BASE_URL = '/companies';

export const ALL = (params?: RequestQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: COMPANIES_BASE_URL,
    params: {
        page_size: 50,
        ...params,
    },
});

/**
 * Request to find an company by id.
 * @param companyId
 */
export const FIND = (companyId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `${COMPANIES_BASE_URL}/${companyId}`,
});

/**
 * Request to find an company by id.
 * @param companyId
 */
export const USERS = (companyId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `${COMPANIES_BASE_URL}/${companyId}/users`,
    params: {
        page_size: 50,
    },
});

/**
 * Request to save a new company.
 * @param company
 */
export const SAVE = (company: CompanyRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: COMPANIES_BASE_URL,
    data: company,
});

/**
 * Request to update an existing company.
 * @param companyId
 * @param company
 */
export const UPDATE = (companyId: number, company: CompanyRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `${COMPANIES_BASE_URL}/${companyId}`,
    data: company,
});

/**
 * Request to delete an company.
 * @param companyId
 */
export const DESTROY = (companyId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `${COMPANIES_BASE_URL}/${companyId}`,
});
